import { Action } from "../../types"

export interface locationDataType { 
    [key:string]:any
}

const initialState:locationDataType = {}
export function LocationDataReducer(state:locationDataType=initialState,action:Action<locationDataType>):locationDataType{
    switch(action.type){
        case "resetLocationData":
            return {...state, ...action.payload};
        case "clearLocationData":
            return {...initialState};
    }
    return state
}
